import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom'; // 👈 Wajib untuk Modal agar tidak terpotong
import { Link } from 'react-router-dom';
import {
    FaSearch, FaPlus, FaEdit, FaTrash, FaUsers,
    FaUserTie, FaPhone, FaEnvelope, FaWhatsapp,
    FaTimes, FaSave, FaEye, FaUserPlus, FaBuilding
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../api/axios';

const AdminTeam = () => {
    // --- STATE DATA ---
    const [teams, setTeams] = useState([]);
    const [managers, setManagers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // --- STATE PAGINATION ---
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRows, setTotalRows] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    // --- STATE MODAL TIM ---
    const [showModal, setShowModal] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        user_id: '',
        phone: ''
    });
    const [selectedManagerInfo, setSelectedManagerInfo] = useState({ name: '', email: '', username: '' });

    // --- STATE MODAL MANAGER BARU ---
    const [showManagerModal, setShowManagerModal] = useState(false);
    const [newManagerData, setNewManagerData] = useState({ name: '', email: '', password: '' });
    const [managerModalLoading, setManagerModalLoading] = useState(false);

    // --- FETCH DATA ---
    const fetchTeams = async () => {
        setIsLoading(true);
        try {
            const response = await api.get('/teams', {
                params: { page, limit, search: searchTerm }
            });
            setTeams(response.data.result);
            setTotalPages(response.data.totalPage);
            setTotalRows(response.data.totalRows);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchManagers = async () => {
        try {
            const response = await api.get('/users/managers');
            setManagers(response.data);
        } catch (error) {
            console.error("Gagal ambil manager", error);
        }
    };

    useEffect(() => {
        const delay = setTimeout(() => fetchTeams(), 500);
        return () => clearTimeout(delay);
        // eslint-disable-next-line
    }, [page, searchTerm]);

    useEffect(() => {
        fetchManagers();
    }, []);

    // --- HANDLER MODAL TIM ---
    const handleOpenModal = (team = null) => {
        if (team) {
            setIsEditMode(true);
            setFormData({
                id: team.id,
                name: team.name,
                user_id: team.user_id || '',
                phone: team.manager_phone || ''
            });
            setSelectedManagerInfo({
                name: team.manager_name,
                email: team.user?.email,
                username: team.user?.username
            });
        } else {
            setIsEditMode(false);
            setFormData({ id: '', name: '', user_id: '', phone: '' });
            setSelectedManagerInfo({ name: '', email: '', username: '' });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    const handleManagerSelect = (e) => {
        const selectedId = e.target.value;
        setFormData({ ...formData, user_id: selectedId });

        const mgr = managers.find(m => m.id === parseInt(selectedId));
        if (mgr) {
            setSelectedManagerInfo({ name: mgr.name, email: mgr.email, username: mgr.username });
        } else {
            setSelectedManagerInfo({ name: '', email: '', username: '' });
        }
    };

    const handleSubmitTeam = async (e) => {
        e.preventDefault();
        setModalLoading(true);
        try {
            if (isEditMode) {
                await api.put(`/teams/${formData.id}`, formData);
                toast.success("Data tim diperbarui!");
            } else {
                await api.post('/teams', formData);
                toast.success("Tim baru ditambahkan!");
            }
            fetchTeams();
            handleCloseModal();
        } catch (error) {
            toast.error(error.response?.data?.msg || "Gagal menyimpan data.");
        } finally {
            setModalLoading(false);
        }
    };

    // --- HANDLER MODAL MANAGER BARU ---
    const handleSubmitNewManager = async (e) => {
        e.preventDefault();
        setManagerModalLoading(true);
        try {
            const res = await api.post('/users/managers', newManagerData);
            toast.success("Manager baru berhasil dibuat!");
            await fetchManagers();

            const createdManager = res.data.data;
            setFormData(prev => ({ ...prev, user_id: createdManager.id }));
            setSelectedManagerInfo({ name: createdManager.name, email: createdManager.email, username: createdManager.username });

            setShowManagerModal(false);
            setNewManagerData({ name: '', email: '', password: '' });

        } catch (error) {
            toast.error(error.response?.data?.msg || "Gagal membuat manager.");
        } finally {
            setManagerModalLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Hapus tim ini? Data atlet juga akan terhapus.")) {
            try {
                await api.delete(`/teams/${id}`);
                toast.success("Tim dihapus.");
                fetchTeams();
            } catch (error) {
                toast.error("Gagal menghapus.");
            }
        }
    };

    return (
        <>
            <div className="container-fluid p-0 animate-fade-in">
                {/* HEADER */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
                    <div>
                        <h4 className="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
                            <FaUsers className="text-primary" /> Manajemen Kontingen
                        </h4>
                        <p className="text-muted m-0 small">Total <b>{totalRows}</b> Tim / Dojang Terdaftar.</p>
                    </div>
                    <button onClick={() => handleOpenModal(null)} className="btn btn-primary d-flex align-items-center gap-2 shadow-sm hover-scale rounded-pill px-4 fw-bold">
                        <FaPlus /> Tambah Tim Baru
                    </button>
                </div>

                {/* SEARCH BAR */}
                <div className="card border-0 shadow-sm mb-4 rounded-4 bg-white">
                    <div className="card-body p-4">
                        <div className="input-group shadow-sm rounded-pill overflow-hidden" style={{ maxWidth: '500px' }}>
                            <span className="input-group-text border-0 bg-light ps-4 text-muted">
                                <FaSearch />
                            </span>
                            <input
                                type="text"
                                className="form-control border-0 bg-light py-2"
                                placeholder="Cari nama tim atau manajer..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1);
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* TABEL DATA TIM */}
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4" style={{ minHeight: '400px' }}>
                    <div className="card-body p-0">
                        {isLoading ? (
                            <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}></div>
                                <span className="text-muted fw-bold">Memuat data tim...</span>
                            </div>
                        ) : teams.length === 0 ? (
                            <div className="text-center py-5">
                                <FaBuilding size={60} className="text-muted opacity-25 mb-3" />
                                <h5 className="text-muted fw-bold">Tidak ada tim ditemukan.</h5>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0" style={{ minWidth: '800px' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th className="py-3 ps-4 text-muted small text-uppercase fw-bold border-0" style={{ letterSpacing: '0.5px' }}>Profil Tim</th>
                                            <th className="py-3 text-muted small text-uppercase fw-bold border-0" style={{ letterSpacing: '0.5px' }}>Manajer</th>
                                            <th className="py-3 text-muted small text-uppercase fw-bold border-0" style={{ letterSpacing: '0.5px' }}>Kontak</th>
                                            <th className="py-3 text-center text-muted small text-uppercase fw-bold border-0" style={{ letterSpacing: '0.5px' }}>Jml Atlet</th>
                                            <th className="py-3 pe-4 text-end text-muted small text-uppercase fw-bold border-0" style={{ letterSpacing: '0.5px' }}>Aksi</th>
                                        </tr>
                                    </thead>
                                    <tbody className="border-top-0">
                                        {teams.map((team, idx) => (
                                            <tr key={idx} className="hover-up-row">
                                                <td className="ps-4 py-3 border-bottom-0">
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="rounded-circle d-flex align-items-center justify-content-center text-primary fw-bold shadow-sm bg-primary bg-opacity-10"
                                                            style={{ width: 45, height: 45, fontSize: '1.2rem' }}>
                                                            {team.name.charAt(0).toUpperCase()}
                                                        </div>
                                                        <span className="fw-black text-dark text-uppercase">{team.name}</span>
                                                    </div>
                                                </td>
                                                <td className="border-bottom-0">
                                                    <div className="d-flex align-items-start gap-3">
                                                        <div className="bg-light text-muted p-2 rounded-circle mt-1">
                                                            <FaUserTie />
                                                        </div>
                                                        <div>
                                                            <span className="fw-bold text-dark d-block">{team.manager_name}</span>
                                                            <small className="text-muted fw-medium">
                                                                @{team.user?.username || 'username_kosong'}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="border-bottom-0">
                                                    <small className="d-flex align-items-center gap-2 text-muted fw-medium mb-1">
                                                        <FaEnvelope className="text-secondary" /> {team.user?.email || team.email || '-'}
                                                    </small>
                                                    {team.manager_phone && (
                                                        <a href={`https://wa.me/${team.manager_phone.replace(/\D/g, '')}`} target="_blank" rel="noreferrer" className="text-decoration-none small text-success fw-bold d-flex align-items-center gap-2">
                                                            <FaWhatsapp /> {team.manager_phone}
                                                        </a>
                                                    )}
                                                </td>
                                                <td className="text-center border-bottom-0">
                                                    <span className="badge bg-info bg-opacity-10 text-info border border-info border-opacity-25 rounded-pill px-3 py-2 shadow-sm">
                                                        {team.athletes_count || 0} Atlet
                                                    </span>
                                                </td>
                                                <td className="pe-4 text-end border-bottom-0">
                                                    <div className="d-flex justify-content-end gap-2">
                                                        <Link
                                                            to={`/admin/tim/${team.uuid}`}
                                                            className="btn btn-light bg-white border text-info hover-scale rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0"
                                                            style={{ width: '35px', height: '35px' }}
                                                            title="Lihat Daftar Atlet"
                                                        >
                                                            <FaEye />
                                                        </Link>
                                                        <button
                                                            onClick={() => handleOpenModal(team)}
                                                            className="btn btn-light bg-white border text-primary hover-scale rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0"
                                                            style={{ width: '35px', height: '35px' }}
                                                            title="Edit"
                                                        >
                                                            <FaEdit />
                                                        </button>
                                                        <button
                                                            onClick={() => handleDelete(team.id)}
                                                            className="btn btn-light bg-white border text-danger hover-scale rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0"
                                                            style={{ width: '35px', height: '35px' }}
                                                            title="Hapus"
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                    {/* Pagination */}
                    <div className="card-footer bg-white p-4 border-top border-light d-flex justify-content-between align-items-center">
                        <small className="text-muted fw-bold">Halaman {page} dari {totalPages || 1}</small>
                        <nav>
                            <ul className="pagination pagination-sm mb-0 gap-1">
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link border-0 text-dark fw-bold rounded-start-pill hover-scale bg-light" onClick={() => page > 1 && setPage(page - 1)}>Prev</button>
                                </li>
                                <li className="page-item active"><button className="page-link border-0 bg-primary fw-bold px-3 shadow-sm">{page}</button></li>
                                <li className={`page-item ${page >= totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link border-0 text-dark fw-bold rounded-end-pill hover-scale bg-light" onClick={() => page < totalPages && setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

            {/* --- MODAL TIM (ADD/EDIT) VIA PORTAL --- */}
            {showModal && createPortal(
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 1050, backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(3px)' }}>
                    <div className="card border-0 shadow-lg rounded-4 p-0 overflow-hidden animate-pop-in" style={{ maxWidth: '500px', width: '90%' }}>
                        <div className="card-header bg-white p-4 border-bottom-0 d-flex justify-content-between align-items-center">
                            <h5 className="fw-bold m-0 text-primary d-flex align-items-center gap-2">
                                <FaBuilding /> {isEditMode ? 'Edit Tim Kontingen' : 'Tambah Tim Baru'}
                            </h5>
                            <button onClick={handleCloseModal} className="btn btn-sm btn-light rounded-circle hover-scale text-danger d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}><FaTimes /></button>
                        </div>
                        <div className="card-body p-4 pt-2">
                            <form onSubmit={handleSubmitTeam}>
                                {/* Nama Tim */}
                                <div className="mb-3">
                                    <label className="form-label small fw-bold text-muted">Nama Tim / Dojang</label>
                                    <input
                                        type="text"
                                        className="form-control bg-light border-0 py-2"
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        required
                                    />
                                </div>

                                {/* Pilihan Manager */}
                                <div className="mb-3">
                                    <label className="form-label small fw-bold text-muted d-flex justify-content-between align-items-center">
                                        Pilih Manajer Penanggung Jawab
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-link text-decoration-none fw-bold p-0 text-primary"
                                            onClick={() => setShowManagerModal(true)}
                                        >
                                            <FaPlus className="me-1" /> Buat Baru
                                        </button>
                                    </label>
                                    <select
                                        className="form-select bg-light border-0 py-2 fw-medium text-dark"
                                        value={formData.user_id}
                                        onChange={handleManagerSelect}
                                        required
                                    >
                                        <option value="">-- Pilih Manajer --</option>
                                        {managers.map(mgr => (
                                            <option key={mgr.id} value={mgr.id}>{mgr.name} (@{mgr.username})</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Preview Info Manager (Readonly) */}
                                <div className="p-3 bg-secondary bg-opacity-10 rounded-4 mb-4 border-0">
                                    <small className="d-block text-muted mb-1 fw-bold">Info Manajer Terpilih:</small>
                                    <div className="fw-black text-dark">{selectedManagerInfo.name || '-'}</div>
                                    <div className="text-muted small d-flex align-items-center gap-2">
                                        <span>@{selectedManagerInfo.username || '...'}</span> • <span>{selectedManagerInfo.email || '...'}</span>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="form-label small fw-bold text-muted">No. WhatsApp Tim (Opsional)</label>
                                    <input
                                        type="text"
                                        className="form-control bg-light border-0 py-2"
                                        placeholder="Contoh: 0812345678"
                                        value={formData.phone}
                                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                    />
                                </div>

                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" onClick={handleCloseModal} className="btn btn-light fw-bold rounded-pill px-4 hover-scale">Batal</button>
                                    <button type="submit" className="btn btn-primary rounded-pill px-4 fw-bold shadow-sm hover-scale d-flex align-items-center gap-2" disabled={modalLoading}>
                                        {modalLoading ? <><div className="spinner-border spinner-border-sm"></div> Menyimpan...</> : <><FaSave /> Simpan Tim</>}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>,
                document.body
            )}

            {/* --- MODAL TAMBAH MANAGER BARU VIA PORTAL --- */}
            {showManagerModal && createPortal(
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 1060, backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(3px)' }}>
                    <div className="card border-0 shadow-lg rounded-4 p-0 overflow-hidden animate-pop-in" style={{ maxWidth: '400px', width: '90%' }}>
                        <div className="card-header bg-warning bg-opacity-10 border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                            <h6 className="fw-bold m-0 text-warning d-flex align-items-center gap-2">
                                <FaUserPlus /> Registrasi Manajer Baru
                            </h6>
                            <button onClick={() => setShowManagerModal(false)} className="btn btn-sm btn-link text-muted p-0"><FaTimes size={18} /></button>
                        </div>
                        <div className="card-body p-4 pt-3">
                            <form onSubmit={handleSubmitNewManager}>
                                <div className="mb-3">
                                    <label className="form-label small fw-bold text-muted">Nama Lengkap</label>
                                    <input
                                        type="text" className="form-control bg-light border-0 py-2" required
                                        value={newManagerData.name}
                                        onChange={e => setNewManagerData({ ...newManagerData, name: e.target.value })}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small fw-bold text-muted">Email Utama</label>
                                    <input
                                        type="email" className="form-control bg-light border-0 py-2" required
                                        value={newManagerData.email}
                                        onChange={e => setNewManagerData({ ...newManagerData, email: e.target.value })}
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="form-label small fw-bold text-muted">Password Sementara</label>
                                    <input
                                        type="text" className="form-control bg-light border-0 py-2" placeholder="Kosongkan untuk default: 123456"
                                        value={newManagerData.password}
                                        onChange={e => setNewManagerData({ ...newManagerData, password: e.target.value })}
                                    />
                                </div>
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="submit" className="btn btn-warning w-100 fw-bold text-white rounded-pill shadow-sm hover-scale" disabled={managerModalLoading}>
                                        {managerModalLoading ? 'Memproses...' : 'Buat Akun Manajer'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>,
                document.body
            )}

            {/* CSS Internal */}
            <style>{`
                .animate-fade-in { animation: fadeIn 0.4s ease-out forwards; }
                .animate-pop-in { animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; }
                .hover-scale { transition: transform 0.2s; }
                .hover-scale:hover { transform: scale(1.05); }
                .hover-up-row { transition: background-color 0.2s; }
                .hover-up-row:hover { background-color: #f8f9fa !important; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes popIn { 
                    0% { transform: scale(0.9); opacity: 0; } 
                    100% { transform: scale(1); opacity: 1; } 
                }
            `}</style>
        </>
    );
};

export default AdminTeam;